<template>
      <b-card
        border-variant="white"
        >
        <font-awesome-icon
          :id="'iconCard-'+num"
          :icon="ics" size="2x"/>
        <b-popover :target="'iconCard-'+num" triggers="hover" placement="top">
          <span class="mx-0 px-1" v-for="t in text" :key="t">
            {{ t }}
         </span>
        </b-popover>
      </b-card>
</template>
<script>

export default {
  props: {
    ics: {
      Type: Array,
      default: []
    },
    text: {
      Type: String,
      default: ''
    },
    num: {
      Type: String,
      default: 0
    }
  }
}

</script>

<style>
</style>
